// Tamil
export const ta = {
  'app.name':           'Kardolive',
  'app.tagline':        'வாடிக்கையாளர் வாயில்',
  'app.signOut':        'வெளியேறு',

  'login.email':        'மின்னஞ்சல்',
  'login.password':     'கடவுச்சொல்',
  'login.signIn':       'உள்நுழை',
  'login.signingIn':    'உள்நுழைகிறது…',
  'login.failed':       'உள்நுழைவு தோல்வி',
  'login.newAccount':   'Kardolive-க்கு புதியவரா?',
  'login.createAccount':'இலவச கணக்கை உருவாக்கு →',

  'nav.workspace':      'பணியிடம்',
  'nav.templates':      'டெம்ப்ளேட்கள்',
  'nav.live':           'நேரலை',
  'nav.rooms':          'அறைகள் & அரட்டை',
  'nav.content':        'உள்ளடக்கம்',
  'nav.developer':      'டெவெலப்பர்',
  'nav.account':        'கணக்கு',

  'nav.overview':       'மேலோட்டம்',
  'nav.projects':       'திட்டங்கள்',
  'nav.chat':           'அரட்டை கன்சோல்',
  'nav.sessions':       'அமர்வுகள்',
  'nav.streams':        'நேரடி ஒளிபரப்பு',
  'nav.studio':         'ஸ்டுடியோ',
  'nav.recordings':     'பதிவுகள்',
  'nav.apiKeys':        'API சாவிகள்',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook சோதிப்பான்',
  'nav.networkTest':    'பிணைய சோதனை',
  'nav.embed':          'பதிக்கப்பட்ட விட்செட்கள்',
  'nav.sdk':            'SDK மற்றும் ஆவணம்',
  'nav.docs':           'Developer docs',
  'nav.analytics':      'பகுப்பாய்வு',
  'nav.settings':       'அமைப்புகள்',

  'overview.welcome':       'மீண்டும் வருக, {name}',
  'overview.plan':          '{tenant} · {plan} திட்டம்',
  'overview.newStream':     'புதிய ஒளிபரப்பு',
  'overview.kpi.live':           'இப்போது நேரடி',
  'overview.kpi.live.broadcasting': 'ஒளிபரப்புகள் நடைபெறுகின்றன',
  'overview.kpi.live.nothing':    'எதுவும் நேரடியாக இல்லை',
  'overview.kpi.total':           'மொத்த ஒளிபரப்புகள்',
  'overview.kpi.total.sub':       'அனைத்து காலங்களிலும்',
  'overview.kpi.sessions':        'அமர்வுகள் · 30 நாட்கள்',
  'overview.kpi.sessions.sub':    'வெளியீட்டு நிகழ்வுகள்',
  'overview.kpi.recordings':      'பதிவுகள்',
  'overview.kpi.recordings.sub':  'இயக்க தயார்',
  'overview.recentStreams':       'சமீபத்திய ஒளிபரப்புகள்',
  'overview.recentSessions':      'சமீபத்திய அமர்வுகள்',
  'overview.viewAll':             'அனைத்தையும் காண →',
  'overview.empty.title':         'இன்னும் ஒளிபரப்புகள் இல்லை',
  'overview.empty.body':          'ஒளிபரப்பத் தொடங்க உங்கள் முதல் ஒளிபரப்பை உருவாக்கவும்.',
  'overview.empty.action':        'ஒளிபரப்பை உருவாக்கு',
  'overview.noSessions':          'இன்னும் அமர்வுகள் இல்லை',

  'status.live':        'நேரடி',
  'status.idle':        'செயல்படாது',
  'status.ended':       'முடிந்தது',
  'status.archived':    'காப்பகப்படுத்தப்பட்டது',

  'common.save':        'சேமி',
  'common.cancel':      'ரத்து செய்',
  'common.delete':      'நீக்கு',
  'common.edit':        'திருத்து',
  'common.create':      'உருவாக்கு',
  'common.confirm':     'உறுதிசெய்',
  'common.loading':     'ஏற்றுகிறது…',
  'common.error':       'பிழை',
  'common.retry':       'மீண்டும் முயற்சி',

  // Dashboard navigation and account controls.
  "nav.skipContent": "பக்க உள்ளடக்கத்திற்குச் செல்லவும்",
  "nav.streamTemplates": "ஒளிபரப்பு வார்ப்புருக்கள்",
  "nav.boards": "ஊடாடும் பலகைகள்",
  "nav.menu": "வழிசெலுத்தலைத் திறக்கவும்",
  "nav.closeMenu": "வழிசெலுத்தலை மூடவும்",
  "nav.scenarios": "பயன்பாட்டுச் சூழல்கள்",
  "nav.premieres": "முதல் காட்சிகள்",
  "nav.clips": "குறுங்காணொளிகள்",
  "dashboard.account": "கணக்கு",
  "dashboard.language": "மொழி",
  "dashboard.appearance": "தோற்றம்",
  "nav.allStreams": "அனைத்து ஒளிபரப்புகளும்",
  "nav.destinations": "ஒளிபரப்பு இலக்குகள்",
  "nav.ecommerce": "மின்னணு வணிகம்",
  "nav.products": "தயாரிப்புகள்",
  "nav.services": "சேவைகள்",
  "nav.collections": "தொகுப்புகள்",
  "nav.orders": "ஆர்டர்கள்",
  "nav.commerceSettings": "வணிக அமைப்புகள்",
  "nav.engagement": "பங்கேற்பு",
  "theme.light": "ஒளிர் முறைக்கு மாறவும்",
  "theme.dark": "இருள் முறைக்கு மாறவும்",
  "role.owner": "உரிமையாளர்",
  "role.admin": "நிர்வாகி",
  "role.member": "உறுப்பினர்",
  "role.viewer": "பார்வையாளர்",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "செயலில்",
  "streams.archived": "காப்பகத்தில்",
  "streams.monitor": "ஒளிபரப்பு மூலக் கண்காணிப்பு",
  "streams.create": "நேரடி ஒளிபரப்பை உருவாக்கு",
  "streams.list": "பட்டியல்",
  "streams.grid": "கட்டம்",
  "streams.view": "ஒளிபரப்புக் காட்சி",
  "streams.searchLabel": "நிகழ்வுகளைத் தேடு",
  "streams.searchHint": "நிகழ்வின் பெயரைத் தேடு",
  "streams.solutionFilter": "வகைப்படி நிகழ்வுகளை வடிகட்டு",
  "streams.statusFilter": "நிலைப்படி நிகழ்வுகளை வடிகட்டு",
  "streams.dateFilter": "உருவாக்கிய தேதிப்படி வடிகட்டு",
  "streams.allSolutions": "அனைத்து வகைகளும்",
  "streams.custom": "இருக்கும் அல்லது தனிப்பயன் அமைப்பு",
  "streams.allStatuses": "அனைத்து நிலைகளும்",
  "streams.anyTime": "எந்த உருவாக்கத் தேதியும்",
  "streams.last7": "கடந்த 7 நாட்களில் உருவாக்கியவை",
  "streams.last30": "கடந்த 30 நாட்களில் உருவாக்கியவை",
  "streams.count": "{total} நிகழ்வுகளில் {shown} காட்டப்படுகின்றன",
  "streams.noMatch": "வடிகட்டிகளுக்குப் பொருந்தும் நிகழ்வுகள் இல்லை.",
  "streams.clearFilters": "வடிகட்டிகளை நீக்கு",
  "streams.refreshFailed": "ஒளிபரப்புப் பட்டியலைப் புதுப்பிக்க முடியவில்லை",
  "streams.loadFailed": "ஒளிபரப்புகளை ஏற்ற முடியவில்லை",
  "streams.stale": "கடைசியாக ஏற்றிய பட்டியல் காட்டப்படுகிறது. நிலைகள் மாறியிருக்கலாம்.",
  "streams.connectionHint": "இணைப்பைச் சரிபார்த்து பட்டியலை மீண்டும் ஏற்றவும்.",
  "streams.retrying": "மீண்டும் முயல்கிறது…",
  "streams.retry": "மீண்டும் முயல்",
  "streams.restoreFailed": "ஒளிபரப்பை மீட்டெடுக்க முடியவில்லை",
  "streams.restoreHint": "மீண்டும் முயலும் முன் இணைப்பைச் சரிபார்த்து, தற்போதைய நிலையை அறிய பட்டியலைப் புதுப்பிக்கவும்.",
  "streams.unused": "பயன்படுத்தாத ஒளிபரப்புகள்: {count}",
  "streams.unusedHint": "ஒளிபரப்புகளோ மறுஒளிபரப்புகளோ இல்லை. பட்டியலை ஒழுங்குபடுத்த காப்பகப்படுத்துங்கள்; எதுவும் நீக்கப்படாது.",
  "streams.reviewArchive": "பரிசீலித்து காப்பகப்படுத்து",
  "streams.loading": "ஒளிபரப்புகளை ஏற்றுகிறது…",
  "streams.archiveEmpty": "காப்பகம் காலியாக உள்ளது. காப்பகப்படுத்திய ஒளிபரப்புகளும் மறுஒளிபரப்புகளும் மீட்டெடுக்கும் வரை இங்கே இருக்கும்.",
  "streams.restore": "மீட்டெடு",
  "streams.firstTitle": "உங்கள் முதல் ஒளிபரப்பை உருவாக்குங்கள்",
  "streams.firstBody": "விற்பனை, வகுப்பு அல்லது சேவைக்கான அமைப்பைத் தேர்ந்தெடுக்கவும் அல்லது வெற்று ஒளிபரப்பில் தொடங்கவும். உலாவி, தொலைபேசி அல்லது OBS மூலம் ஒளிபரப்பலாம்.",
  "streams.blank": "வெற்று ஒளிபரப்பு",
  "streams.broadcasts": "ஒளிபரப்புகள்: {count}",
  "streams.replays": "மறுஒளிபரப்புகள்: {count}",
  "streams.sessions": "அமர்வுகள்: {count}",
  "streams.recordings": "பதிவுகள்: {count}",
  "streams.mode.BROADCAST": "ஒளிபரப்பு",
  "streams.mode.LOW_LATENCY": "குறைந்த தாமதம்",
  "streams.mode.REALTIME": "நிகழ்நேரம்",
  "streams.key": "விசை",
  "streams.archiveTitle": "பயன்படுத்தாத ஒளிபரப்புகளைக் காப்பகப்படுத்து",
  "streams.archiveHint": "இவை இதுவரை ஒளிபரப்பப்படவில்லை. காப்பகத்தில் என்ற தாவலில் எப்போது வேண்டுமானாலும் மீட்டெடுக்கலாம்.",
  "streams.archiveFailed": "{count} ஒளிபரப்புகளைக் காப்பகப்படுத்த முடியவில்லை; அவை நேரலையில் தொடங்கியிருக்கலாம். மற்றவை காப்பகப்படுத்தப்பட்டன.",
  "streams.archiving": "காப்பகப்படுத்துகிறது…",
  "streams.archiveCount": "{count} காப்பகப்படுத்து",
  "streamType.webinar": "வணிக இணையக் கருத்தரங்குகள் மற்றும் அறிமுகங்கள்",
  "streamType.classroom": "வகுப்புகள் மற்றும் தனிப்பயிற்சி",
  "streamType.training": "நிறுவனப் பயிற்சி",
  "streamType.conference": "மாநாடுகள் மற்றும் கண்காட்சிகள்",
  "streamType.shopping": "நேரடி விற்பனை",
  "streamType.auction": "நேரடி ஏலங்கள்",
  "streamType.consultation": "தனிப்பட்ட ஆலோசனைகள்",
  "streamType.creator": "படைப்பாளர்கள் மற்றும் சமூக நேரலை",
  "streamType.audio": "ஒலி அறைகள் மற்றும் பாட்காஸ்ட்கள்",
  "streamType.sports": "விளையாட்டு மற்றும் மின்னணு விளையாட்டு",
  "streamType.performance": "இசைக் கச்சேரிகள் மற்றும் நிகழ்ச்சிகள்",
  "streamType.community": "வழிபாடு மற்றும் நிதி திரட்டல்",
  "streamType.tour": "சுற்றுப்பயணங்கள் மற்றும் செயல்விளக்கங்கள்",
  "streamType.fitness": "உடற்பயிற்சி மற்றும் பட்டறைகள்",
  "streamType.public-meeting": "செய்திகள் மற்றும் பொதுக் கூட்டங்கள்",
  "streamType.continuous": "தொடர் சேனல்கள் மற்றும் கேமராக்கள்",
  "streams.close": "மூடு",
};
